import { render, staticRenderFns } from "./StartProject.vue?vue&type=template&id=0fbbfd0a&scoped=true&"
import script from "./StartProject.vue?vue&type=script&lang=js&"
export * from "./StartProject.vue?vue&type=script&lang=js&"
import style0 from "./StartProject.vue?vue&type=style&index=0&id=0fbbfd0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbfd0a",
  null
  
)

export default component.exports